module.exports = __webpack_public_path__ + "static/mujeres007.thumb-391f56aa91ce4f880faf2670fdaedbc7.jpg";